import React from 'react';
import { FormattedDate, FormattedTime, FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { RouterOutput } from '../../api/trpc';
import { isSameDay } from 'date-fns';

type Item = RouterOutput['schedules']['list'][number];

type Props = {
  schedule: Item;
};

export const ScheduleLabel = ({ schedule }: Props) => {
  const { startAt, endAt, processed, missed } = schedule;

  return (
    <>
      <Typography sx={{ color: 'text.disabled' }}>
        <FormattedDate value={startAt} day="numeric" month="short" />{' '}
        <FormattedTime value={startAt} /> -{' '}
        {isSameDay(new Date(startAt), new Date(endAt)) ? (
          <FormattedTime value={endAt} />
        ) : (
          <>
            <FormattedDate value={endAt} day="numeric" month="short" />{' '}
            <FormattedTime value={endAt} />
          </>
        )}
      </Typography>

      <Typography
        sx={{
          my: 0.25,
          fontWeight: !processed && !missed ? 600 : undefined,
        }}
      >
        {schedule.type === 'battery-charge' && (
          <FormattedMessage
            id="schedules.battery_charge"
            defaultMessage="Nabíjení baterie"
          />
        )}
        {schedule.type === 'battery-discharge' && (
          <FormattedMessage
            id="schedules.battery_discharge"
            defaultMessage="Vybíjení baterie"
          />
        )}
        {schedule.type === 'ev-charging' && (
          <FormattedMessage
            id="schedules.ev_charging"
            defaultMessage="Nabíjení elektromobilu"
          />
        )}
      </Typography>

      <Typography sx={{ color: 'text.disabled' }}>
        {'targetSoc' in schedule && typeof schedule.targetSoc === 'number' && (
          <FormattedMessage
            id="schedules.target_soc"
            defaultMessage="Cílové SOC: {targetSoc, number, percent}"
            values={{ targetSoc: schedule.targetSoc / 100 }}
          />
        )}
        {'chargingCurrent' in schedule &&
          typeof schedule.chargingCurrent === 'number' && (
            <FormattedMessage
              id="schedules.charging_current"
              defaultMessage="Nabíjecí proud: {chargingCurrent} A"
              values={{ chargingCurrent: schedule.chargingCurrent }}
            />
          )}
      </Typography>
    </>
  );
};
